module.exports = __webpack_public_path__ + "img/weChart.79ac6364.svg";